import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../UserContext";
import { LoadingOutlined } from "@ant-design/icons";
import Logged from "../Components/Profile.jsx";
import TryLogin from "../Components/TryLogin";
import SEO from "../Components/SEO";

export default function ChangePassword() {
  const { user, changePassword } = useContext(UserContext);
  const [newPassword, setNewpassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setoldPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };
  const handleNewPassword = (e) => {
    setNewpassword(e.target.value);
  };
  const handleOldPassword = (e) => {
    setoldPassword(e.target.value);
  };
  const changeUserPassword = async (e) => {
    e.preventDefault();
    if (newPassword === confirmPassword) {
      let token = user?.token;
      setLoading(true);
      try {
        /*to debug
         * no getting the response well
         */
        let { success, message } = await changePassword("change", {
          old_password: oldPassword,
          new_password: newPassword,
          token,
        });

        if (success) {
          window.Toast.fire({
            icon: "success",
            title: message || "Worked as expected",
          });
          setoldPassword("");
          setNewpassword("");
          setConfirmPassword("");
        } else {
          window.displayToastError("Invalid old password");
        }
      } catch (e) {
        window.displayToastError("Invalid old password");
      }
      setLoading(false);
    } else {
      window.displayToastError("Passwords don't match");
    }
  };

  return (
    <>
      <SEO title={`Change Password`}></SEO>
      <div className="sm:px-5 lg:px-60 pb-12 lg:pb-0">
        <div className="">
          <div className="px-4 lg:px-0 lg:flex w-full gap-10">
            <div className="lg:w-1/2">
              <form onSubmit={changeUserPassword}>
                <h1 className=" mt-10 mb-3 text-sm font-bold">
                  Change password
                </h1>
                <div className="form-group">
                  <input
                    autoComplete="off"
                    type="password"
                    id="password3"
                    placeholder="Old Password"
                    value={oldPassword}
                    onChange={handleOldPassword}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <input
                    autoComplete="off"
                    type="password"
                    id="password1"
                    placeholder="New Password"
                    value={newPassword}
                    onChange={handleNewPassword}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <input
                    autoComplete="off"
                    type="password"
                    id="password2"
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={handleConfirmPassword}
                    className="form-control"
                  />
                </div>

                <div className="form-group flex items-center">
                  <div className="w-1/2">
                    {loading ? (
                      <button
                        type="submit"
                        className="py-2 px-3 rounded-md bg-fire text-white opacity-50 gap-1 flex items-center justify-center"
                        style={{ fontSize: "13px" }}
                      >
                        {" "}
                        <LoadingOutlined /> <span>Changing ...</span>
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="py-2 px-3 rounded-md bg-fire text-white"
                        style={{ fontSize: "13px" }}
                      >
                        Change password
                      </button>
                    )}
                  </div>

                  <div className="w-1/2">
                    <div className="flex justify-end mt-2 ">
                      <Link
                        to="/edit-profile"
                        className="text-gray-500 hover:underline"
                      >
                        Edit profile
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div className="lg:w-1/2">
              {user.token ? <Logged /> : <TryLogin />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
